module.exports = __webpack_public_path__ + "img/PropertyTypes.5e89d011.svg";